export const SubscriptionCancelReasons = [
  "I no longer manage properties",
  "The platform didn't meet my expectations",
  "The subscription cost is too high",
  "I found a better alternative",
  "I had technical issues with the platform",
];